import { Tracker } from '@leverege/molten/tracking';
const SOURCES = {
  FIND_ASSET_DETAILS: 'Find Asset - Details Screen',
  FIND_ASSET_LIST: 'Find Asset - List Card',
  FIND_TAG_DETAILS: 'Find Tag - Details Screen',
  FIND_TAG_LIST: 'Find Tag - List Card',
  RIGHT_CLICK: 'Right Click'
};
const EVENT_NAMES = {
  RING_TAG: 'Ring Tag - Ring tag',
  CANCEL_RING_TAG: 'Ring Tag - Cancel Ring tag'
};
const getEventName = type => {
  return type === 'ring' ? EVENT_NAMES.RING_TAG : EVENT_NAMES.CANCEL_RING_TAG;
};
export const getRingTagEventSource = client => {
  const isRightClick = client === 'ListDataViewer' || client === undefined;
  if (isRightClick) {
    return SOURCES.RIGHT_CLICK;
  }
  const isDetailsScreen = client === 'ItemInfoScreen';
  return isDetailsScreen ? SOURCES.FIND_TAG_DETAILS : SOURCES.FIND_TAG_LIST;
};
export const amplitudeRingTagTrackEvent = (source, type) => {
  const eventName = getEventName(type);
  const actionName = type === 'ring' ? 'Ring Tag' : 'Cancel Ring Tag';
  Tracker.event(eventName, {
    source,
    actionName,
    blueprint: 'Asset',
    url: window.location.href
  });
};
export async function amplitudeCancelRingTagTrackEvent(from) {
  Tracker.event('Action Initiated', {
    actionName: 'Cancel Ring Tag',
    selectedFrom: from,
    blueprint: 'Asset',
    url: window.location.href
  });
}